import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CardTitle, Row, Col, UncontrolledCollapse, Button } from "reactstrap";

const Collapse = ({ questionsArray, title, items }: any) => {
  const { t } = useTranslation();
  const [id, setId] = useState("");

  return (
    <Row>
      <Col xs="12">
        <CardTitle>
          <h2>
            <span className="fs-5 fw-bold text-secondary-two-light pt-3 title-bordre-bottom">
              {title}
            </span>
          </h2>
          <br />
        </CardTitle>
        <div className="list collapse-list">
          <ul>
            {questionsArray.map((item: any, index: number) => (
              <li>
                {item.id ? (
                  <>
                    <div
                      id={item.id}
                      className=" d-flex justify-content-between align-items-center "
                      onClick={() => setId(item.id)}
                    >
                      <span className="fs-7 lh-md-sm">{t(item.question)}</span>
                      <i className="icon-circle-down" />
                    </div>
                    <UncontrolledCollapse
                      toggler={item.id}
                      defaultOpen={item.id == "toggler1"}
                    >
                      <p className="fs-6 py-3 text-secondary-two-light">
                        {t(item.answer)}
                      </p>
                    </UncontrolledCollapse>
                  </>
                ) : (
                  <> </>
                )}
              </li>
            ))}
          </ul>
        </div>
      </Col>
    </Row>
  );
};
export default Collapse;
